import * as excel from "@script/excel";

export async function scheduleDownload_excel(roster: {
  schedule_id: string;
  year: number;
  month: number;
}) {
  try {
    await excel.schedule_download(
      roster.schedule_id,
      roster.year,
      roster.month
    );
  } catch (error) {
    alert("다운로드에 실패했습니다.");
  }
}
